import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/theme.css";
/* neo.css 必须在 theme.css 之后加载（覆盖旧 8-bit 令牌） */
import "./styles/neo.css";
import "./styles/products.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
